import {spotheroPatch} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import {type InventoryRule} from 'api/inventory/inventory.types';
import {type RawApiResponse} from 'api/api.types';

type UpdateExceptionResponse = InventoryRule;

type UpdateExceptionRawResponse = RawApiResponse<UpdateExceptionResponse>;

/**
 * Format the response from the update exception API call.
 * @function formatUpdateExceptionResponse
 * @param response - The response from the update exception API call.
 *
 * @memberof module:api/inventory/dto
 */
const formatUpdateExceptionResponse = (
    response: UpdateExceptionRawResponse
) => {
    const formattedResponse = camelizeKeys(response);

    return formattedResponse;
};

/**
 * Update an inventory rule exception for a given facility.  Used when editing a single property of an inventory rule (e.g. status).
 * @param facilityId - The facility id.
 * @param ruleId - The rule id.
 * @param  values - The inventory rule properties to update.
 *
 * @see '/api/v1/facilities/{facilityId}/inventory-rules/{ruleId}/'
 *
 */
const updateException = async (
    facilityId: number,
    ruleId: number,
    values: Partial<InventoryRule>
) => {
    try {
        const {data} = await spotheroPatch<UpdateExceptionRawResponse>(
            `facilities/${facilityId}/inventory-rules/${ruleId}/`,
            values
        );

        const formattedResponse = formatUpdateExceptionResponse(data.data);

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default updateException;
